import Phaser from 'phaser';
import { MainMenu } from '../ui/MainMenu';
import { Lobby, type LobbyResult } from '../ui/Lobby';
import { StageSelect } from '../ui/StageSelect';
import { resolveServerUrl, type MultiSession, type Session } from '../session';

export class BootScene extends Phaser.Scene {
  constructor() {
    super('BootScene');
  }

  preload(): void {
    // MVP: no external assets yet. Register placeholder audio here when available:
    // this.load.audio('footstep', '/assets/audio/footstep.ogg');
    // this.load.audio('interactSwing', 'interact_swing');
    // this.load.audio('interactHit', 'interact_hit');
    // this.load.audio('jump', 'jump');
    // this.load.audio('land', 'land');
  }

  create(): void {
    const panel = document.querySelector('#blocker .panel') as HTMLElement | null;
    if (!panel) {
      this.scene.start('MainGameScene', { session: { mode: 'single', stageIndex: 0 } satisfies Session });
      return;
    }
    const saved = panel.innerHTML;
    panel.innerHTML = '';
    const menu = new MainMenu(panel, resolveServerUrl(), {
      onSingle: () => {
        menu.dispose();
        this.openStageGrid(panel, saved);
      },
      onHost: (serverUrl, code, name) => {
        menu.dispose();
        this.openLobby(panel, saved, serverUrl, code, name, true);
      },
      onJoin: (serverUrl, code, name) => {
        menu.dispose();
        this.openLobby(panel, saved, serverUrl, code, name, false);
      },
    });
  }

  private openStageGrid(panel: HTMLElement, savedPanel: string): void {
    const grid = new StageSelect(panel, {
      onPick: (index) => {
        grid.dispose();
        panel.innerHTML = savedPanel;
        this.scene.start('MainGameScene', {
          session: { mode: 'single', stageIndex: index } satisfies Session,
        });
      },
      onBack: () => {
        grid.dispose();
        this.create();
      },
    });
  }

  private openLobby(
    panel: HTMLElement,
    savedPanel: string,
    serverUrl: string,
    code: string,
    name: string,
    isHost: boolean,
  ): void {
    const lobby = new Lobby(panel, serverUrl, code, name, isHost, {
      onGameStart: (r: LobbyResult) => {
        lobby.release();
        panel.innerHTML = savedPanel;
        const session: MultiSession = {
          mode: 'multi',
          serverUrl,
          code: r.code,
          name,
          color: r.color,
          net: r.net,
          selfId: r.selfId,
          players: r.players,
          spawns: r.spawns,
          stageIndex: r.stageIndex,
          isHost: r.isHost,
        };
        this.scene.start('MainGameScene', { session });
      },
      onLeave: () => {
        lobby.dispose();
        this.create();
      },
    });
  }
}
